import React from 'react';
import { getPlatform } from '../../constants/platforms';
import amazonLogo from '../../assets/platform-logos/amazon.png';
import blinkitLogo from '../../assets/platform-logos/blinkit.png';
import zeptoLogo from '../../assets/platform-logos/zepto.png';
import instamartLogo from '../../assets/platform-logos/instamart.png';

const BUNDLED_LOGOS = {
  amazon: { mark: amazonLogo, wordmark: amazonLogo },
  blinkit: { mark: blinkitLogo },
  zepto: { mark: zeptoLogo },
  instamart: { mark: instamartLogo },
};

/**
 * Marketplace logo marks bundled in the app (Amazon, Blinkit, Zepto, Instamart).
 */
export default function PlatformLogo({
  platformId,
  size = 20,
  className = '',
  variant = 'mark',
}) {
  const platform = getPlatform(platformId);
  const bundled = BUNDLED_LOGOS[platformId];
  const src = bundled
    ? (variant === 'wordmark' && bundled.wordmark ? bundled.wordmark : bundled.mark)
    : (variant === 'wordmark' && platform.logoWordmark ? platform.logoWordmark : platform.logo);

  if (!src) {
    return (
      <span
        className={`inline-block rounded-full flex-shrink-0 ${className}`}
        style={{ width: size, height: size, backgroundColor: platform.brandColor }}
        aria-hidden
      />
    );
  }
  const isWide = variant === 'wordmark' || platformId === 'amazon';
  const width = isWide ? Math.round(size * 2.4) : size;

  return (
    <img
      src={src}
      alt={`${platform.name} logo`}
      width={width}
      height={size}
      className={`object-contain flex-shrink-0 ${className}`}
      style={{ maxHeight: size, width, height: size }}
      loading="lazy"
      decoding="async"
    />
  );
}
